import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, ButtonModule, RouterModule, ProgressSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor() {
    const savedTheme = localStorage.getItem('theme');
    const element = document.querySelector('html');
    if (savedTheme === 'dark') {
      element!.classList.add('dark-mode');
    }
  }
}
